define('home/views/ChannelsView',[
    'underscore',
    'backbone',
    'backbone-marionette',

    'core/strings',

    'home/models/Session',
    'home/views/RecommendationsModuleView',
    'home/views/UserChannelsView',
    'home/views/HomepageChannelsModuleView',

    'home/mixins/withEmailConfirmedModal',
    'home/mixins/withSubviews',

    'home/templates/channels',
], function (
    _,
    Backbone,
    Marionette,

    strings,

    Session,
    RecommendationsModuleView,
    UserChannelsView,
    HomepageChannelsModuleView,

    withEmailConfirmedModal,
    withSubviews,

    channelsTemplate
) {
    'use strict';

    var gettext = strings.get;

    /**
     * The view that shows for the Channels section in the nav.
     * Shows a list of channels of interest to the logged in user:
     * followed channels and managed channels.
     *
     * Expects a ChannelsViewModel
     * Expects the user to be logged in. Main content area is empty
     * for anon users.
     */
    var ChannelsView = Marionette.ItemView.extend({
        template: channelsTemplate,

        regions: {
            recommendedUsersModuleRegion: '[data-role=recommend-module][data-recommend-type=user]',
            recommendedChannelsModuleRegion: '[data-role=recommend-module][data-recommend-type=channel]',
            contentRegion: '[data-role=content-area]',
        },

        initialize: function () {
            var session = Session.get();
            session.loadPromise().always(_.bind(this.render, this));
        },

        onRender: function () {
            this.activateRegion(this.contentRegion, this.createContentView);
            this.activateRegion(this.recommendedUsersModuleRegion, this.createUserRecommendedModuleView);

            this.model.promotedChannels.ensureFetched().then(_.bind(function () {
                var filteredChannels = this.model.promotedChannels
                    .chain()
                    .reject(function (channel) {
                        return channel.primaryForum.get('isFollowing');
                    })
                    .shuffle()
                    .value();

                if (filteredChannels.length) {
                    // Only show channels module if there are some Channels
                    // the user hasn't followed yet.
                    this.activateRegion(this.recommendedChannelsModuleRegion,
                        _.bind(this.createChannelRecommendedModuleView, this, filteredChannels));
                }
            }, this));
        },

        createContentView: function () {
            return new UserChannelsView({
                model: this.model.sessionUserProfile,
            });
        },

        createUserRecommendedModuleView: function () {
            return RecommendationsModuleView.createUserRecommendedModuleView({
                model: this.model.interestingUsers,
            });
        },

        createChannelRecommendedModuleView: function (filteredChannels) {
            return new HomepageChannelsModuleView({
                collection: new Backbone.Collection(filteredChannels),
            });
        },

        getMetaAttrs: function () {
            return gettext('Channels');
        },
    });

    withEmailConfirmedModal.call(ChannelsView.prototype);
    withSubviews.call(ChannelsView.prototype);

    return ChannelsView;
});

